import { strip } from "../utils";

const pairs = [
  ["австралия", "australia"],
  ["вануату", "vanuatu"],
  ["кирибати", "kiribati"],
  ["маршалловы острова", "marshall islands"],
  ["науру", "nauru"],
  ["новая зеландия", "new zealand"],
  ["палау", "palau"],
  ["папуа — новая гвинея", "papua new guinea"],
  ["самоа", "samoa"],
  ["соломоновы острова", "solomon islands"],
  ["тонга", "tonga"],
  ["тувалу", "tuvalu"],
  ["федеративные штаты микронезии", "federated states of micronesia"],
  ["фиджи", "fiji"],
  ["абхазия", "abkhazia"],
  ["азербайджан", "azerbaijan"],
  ["армения", "armenia"],
  ["афганистан", "afghanistan"],
  ["бангладеш", "bangladesh"],
  ["бахрейн", "bahrain"],
  ["бруней", "brunei"],
  ["бутан", "bhutan"],
  ["восточный тимор", "east timor"],
  ["вьетнам", "vietnam"],
  ["грузия", "georgia"],
  ["израиль", "israel"],
  ["индия", "india"],
  ["индонезия", "indonesia"],
  ["иордания", "jordan"],
  ["ирак", "iraq"],
  ["иран", "iran"],
  ["йемен", "yemen"],
  ["казахстан", "kazakhstan"],
  ["камбоджа", "cambodia"],
  ["катар", "qatar"],
  ["киргизия", "kyrgyzstan"],
  ["китай", "china"],
  ["кувейт", "kuwait"],
  ["лаос", "laos"],
  ["ливан", "lebanon"],
  ["малайзия", "malaysia"],
  ["мальдивы", "maldives"],
  ["монголия", "mongolia"],
  ["мьянма", "myanmar"],
  ["непал", "nepal"],
  ["оаэ", "uae"],
  ["оман", "oman"],
  ["пакистан", "pakistan"],
  ["россия", "russia"],
  ["саудовская аравия", "saudi arabia"],
  ["северная корея", "north korea"],
  ["сингапур", "singapore"],
  ["сирия", "syria"],
  ["таджикистан", "tajikistan"],
  ["таиланд", "thailand"],
  ["тайва́нь", "taiwan"],
  ["туркмения", "turkmenistan"],
  ["турция", "turkey"],
  ["узбекистан", "uzbekistan"],
  ["филиппины", "philippines"],
  ["шри-ланка", "sri lanka"],
  ["южная корея", "south korea"],
  ["южная осетия", "south ossetia"],
  ["япония", "japan"],
  ["алжир", "algeria"],
  ["ангола", "angola"],
  ["бенин", "benin"],
  ["ботсвана", "botswana"],
  ["буркина фасо", "burkina faso"],
  ["бурунди", "burundi"],
  ["габон", "gabon"],
  ["гамбия", "gambia"],
  ["гана", "ghana"],
  ["гвинея", "guinea"],
  ["гвинея-бисау", "guinea-bissau"],
  ["джибути", "djibouti"],
  ["египет", "egypt"],
  ["замбия", "zambia"],
  ["зимбабве", "zimbabwe"],
  ["кабо-верде", "cape verde"],
  ["камерун", "cameroon"],
  ["кения", "kenya"],
  ["коморы", "comoros"],
  ["демократическая республика конго", "democratic republic of the congo"],
  ["республика конго", "republic of the congo"],
  ["кот-д’ивуар", "côte d'ivoire"],
  ["лесото", "lesotho"],
  ["либерия", "liberia"],
  ["ливия", "libya"],
  ["маврикий", "mauritius"],
  ["мавритания", "mauritania"],
  ["мадагаскар", "madagascar"],
  ["малави", "malawi"],
  ["мали", "mali"],
  ["марокко", "morocco"],
  ["мозамбик", "mozambique"],
  ["намибия", "namibia"],
  ["нигер", "niger"],
  ["нигерия", "nigeria"],
  ["руанда", "rwanda"],
  ["сан-томе и принсипи", "sao tome and principe"],
  ["свазиленд", "swaziland"],
  ["сейшелы", "seychelles"],
  ["сенегал", "senegal"],
  ["сомали", "somalia"],
  ["судан", "sudan"],
  ["сьерра-леоне", "sierra leone"],
  ["танзания", "tanzania"],
  ["того", "togo"],
  ["тунис", "tunisia"],
  ["уганда", "uganda"],
  ["центральноафриканская республика", "central african republic"],
  ["чад", "chad"],
  ["экваториальная гвинея", "equatorial guinea"],
  ["эритрея", "eritrea"],
  ["эфиопия", "ethiopia"],
  ["южно-африканская республика", "south africa"],
  ["австрия", "austria"],
  ["албания", "albania"],
  ["андорра", "andorra"],
  ["англия", "england"],
  ["белоруссия", "belarus"],
  ["бельгия", " belgium"],
  ["болгария", "bulgaria"],
  ["босния и герцеговина", "bosnia and herzegovina"],
  ["ватикан", "vatican"],
  ["великобритания", "great britain"],
  ["венгрия", "hungary"],
  ["германия", "germany"],
  ["греция", "greece"],
  ["дания", "denmark"],
  ["ирландия", "ireland"],
  ["исландия", "iceland"],
  ["испания", "spain"],
  ["италия", "italy"],
  ["кипр", "cyprus"],
  ["косово", "kosovo"],
  ["латвия", "latvia"],
  ["литва", "lithuania"],
  ["лихтенштейн", "liechtenstein"],
  ["люксембург", "luxembourg"],
  ["македония", "macedonia"],
  ["мальта", "malta"],
  ["молдавия", "moldova"],
  ["монако", "monaco"],
  ["нидерланды", "netherlands"],
  ["норвегия", "norway"],
  ["польша", "poland"],
  ["португалия", "portugal"],
  ["россия", "russia"],
  ["румыния", "romania"],
  ["сан-марино", "san marino"],
  ["сербия", "serbia"],
  ["словакия", "slovakia"],
  ["словения", "slovenia"],
  ["северного кипра", "northern cyprus"],
  ["северная ирландия", "northern ireland"],
  ["турция", "turkey"],
  ["украина", "ukraine"],
  ["уэльс", "wales"],
  ["финляндия", "finland"],
  ["франция", "france"],
  ["хорватия", "croatia"],
  ["черногория", "montenegro"],
  ["чехия", "czech republic"],
  ["швейцария", "switzerland"],
  ["швеция", "sweden"],
  ["шотландия", "scotland"],
  ["эстония", "estonia"],
  ["антигуа и барбуда", "antigua and barbuda"],
  ["багамы", "bahamas"],
  ["барбадос", "barbados"],
  ["белиз", "belize"],
  ["гаити", "haiti"],
  ["гватемала", "guatemala"],
  ["гондурас", "honduras"],
  ["гренада", "grenada"],
  ["доминика", "dominica"],
  ["доминиканская республика", "dominican republic"],
  ["канада", "canada"],
  ["коста-рика", "costa rica"],
  ["мексика", "mexico"],
  ["никарагуа", "nicaragua"],
  ["панама", "panama"],
  ["сальвадор", "el salvador"],
  ["сент-люсия", "saint lucia"],
  ["сент-винсент и гренадины", " saint vincent and the grenadines"],
  ["сент-китс и невис", "saint kitts and nevis"],
  ["соединённые штаты америки (сша)", "united states of america (usa)"],
  ["тринидад и тобаго", "trinidad and tobago"],
  ["ямайка", "jamaica"],
  ["аргентина", "argentina"],
  ["бразилия", "brazil"],
  ["боливия", "bolivia"],
  ["венесуэла", "venezuela"],
  ["гайана", "guyana"],
  ["колумбия", "colombia"],
  ["парагвай", "paraguay"],
  ["перу", "peru"],
  ["суринам", "suriname"],
  ["уругвай", "uruguay"],
  ["французская гвиана", "french guiana"],
  ["чили", "chile"],
  ["эквадор", "ecuador"],
];

const map = new Map<string, string>(pairs as any);

export function translate(name: string) {
  const key = strip(name).toLowerCase();
  return map.get(key);
}
